var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_4114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 57C57.5776 57 64.8449 53.9973 70.203 48.6525C75.5612 43.3078 78.5714 36.0587 78.5714 28.5C78.5714 20.9413 75.5612 13.6922 70.203 8.34746C64.8449 3.00267 57.5776 0 50 0C42.4224 0 35.1551 3.00267 29.7969 8.34746C24.4388 13.6922 21.4286 20.9413 21.4286 28.5C21.4286 36.0587 24.4388 43.3078 29.7969 48.6525C35.1551 53.9973 42.4224 57 50 57ZM39.7991 67.6875C17.8125 67.6875 0 85.4555 0 107.387C0 111.039 2.96875 114 6.62946 114H93.3705C97.0312 114 100 111.039 100 107.387C100 85.4555 82.1875 67.6875 60.2009 67.6875H39.7991Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_4114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolid);
export default __webpack_public_path__ + "static/media/user-solid.91c0a91fc55a5395a867dd532298edfe.svg";
export { ForwardRef as ReactComponent };